export default __webpack_public_path__ + "HenrySans-Bold.b942e35a350c3bd2b2036e765a3e72a3.woff2";